<template>
  <v-row no-gutters class="mb-12 pt-12 mt-10">
    <Upper />
    <v-col cols="1" md="1" xs="1" sm="1"></v-col>
    <v-col cols="10" md="10" xs="10" sm="10">
      <v-row no-gutters>
        <v-col cols="2" md="1" xs="2" sm="2">
          <v-img
            src="@/assets/logoOne.png"
            max-width="87px"
            max-height="124.73px"
          ></v-img>
        </v-col>
        <v-col cols="10" md="3" xs="10" sm="10">
          <div style="font-size: 34px; font-weight: 500; line-height: 44.2px">
            ONE Conference
          </div>
          <div style="font-size: 24px; font-weight: 500; line-height: 31.2px">
            Anywhere Anytime
          </div>
        </v-col>
        <v-col cols="12" md="7" xs="12" sm="12">
          <div
            style="
              color: red;
              font-size: 22px;
              font-weight: 500;
              line-height: 31.2px;
            "
          >
          {{$t("activatepage.nopermission") }}
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-6">
        <v-col cols="12" md="12" xs="12" sm="12">
          <v-row class="mt-n7">
            <v-col cols="12" md="4" xs="12" sm="12"> </v-col>
            <v-col cols="12" md="8" xs="12" sm="12">
              <div
                style="font-size: 20px; font-weight: 500; line-height: 31.2px"
              >
              {{$t("activatepage.permission") }}
              </div>
            </v-col>
          </v-row>
          <v-row class="mt-n4">
            <v-col cols="12" md="4" xs="12" sm="12"> </v-col>
            <v-col
              cols="12"
              md="1"
              xs="12"
              sm="12"
              v-for="(datainputs, index) in datainput"
              :key="datainputs.id"
            >
              <v-text-field
                dense
                v-mask="mask"
                v-model="datainputs.input"
                outlined
                ref="datainput"
                persistent-placeholder
                @input="moveToNextField(datainputs.input, index)"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" xs="12" sm="12">
              <v-btn
                color="#04449F"
                class="white--text buttonMC"
                block
                :loading="loading"
                :disabled="loading"
                elevation="4"
                @click="sentocode(datainput.input)"
                >{{$t("button.btnok") }}
                <template v-slot:loader>
                  <span>Loading...</span>
                </template>
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mt-n4">
            <v-col cols="12" md="4" xs="12" sm="12"> </v-col>
            <v-col cols="12" md="6" xs="12" sm="12">
              <div
                style="font-size: 18px; font-weight: 500; line-height: 31.2px"
              >
                *{{$t("activatepage.nocode") }}
              </div>
            </v-col>
          </v-row>
          <v-row class="mt-n4">
            <v-col cols="12" md="4" xs="12" sm="12"> </v-col>
            <v-col cols="12" md="6" xs="12" sm="12">
              <div
                style="font-size: 20px; font-weight: 500; line-height: 31.2px"
              >
              {{$t("activatepage.backtojoincode") }}
                <span class="pl-1 pointer" @click="gojoinpage()" style="color:#0C2FE0; font-size: 20px; text-decoration: underline; cursor: pointer;">{{$t("loginpage.click") }}</span>
              </div>
              <!-- <v-btn
                    depressed
                    @click="gojoinpage()"
                    block
                    rounded
                    outlined
                    color="primary"
                  >
                  กลับไปหน้าเข้าร่วมด้วยรหัส
                  </v-btn> -->
            </v-col>
          </v-row>
          <!-- <v-row class="mt-n7"  v-if="diserror === true">
      <v-col cols="12" md="6" xs="12" sm="12" align-self="center">
      </v-col>
      <v-col cols="12" md="6" xs="12" sm="12">
        <div style="font-family: Sarabun; color: red; font-size: 20px; font-weight: 500; line-height: 31.2px;">
          บัญชีหมดอายุการใช้งาน
        </div>
      </v-col>
        </v-row> -->
        </v-col>
      </v-row>
      <v-row no-gutters> </v-row>
    </v-col>
    <v-col cols="1" md="1" xs="1" sm="1"></v-col>
  </v-row>
</template>
<script>
import Upper from "../upper";
import { mask } from 'vue-the-mask'
export default {
  directives: {
    mask
  },
  components: {
    Upper,
  },
  data() {
    return {
      mask: 'XXXX',
      loading: false,
      loader: null,
      loadersucc: null,
      key: '',
      datainput: [
        { id: "1", input: "" },
        { id: "2", input: "" },
        { id: "3", input: "" },
        { id: "4", input: "" },
      ],
      jwt: require("jsonwebtoken"),
      sharedtoken: "",
      dataUser: "",
      oneid: "",
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 8000);
      this.loader = null;
    },
    loadersucc() {
      const l = this.loadersucc;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 8000);
      this.loadersucc = null;
      this.inputlocalStorage();
    },
  },
  created() {
    if (localStorage.getItem("user-token") === null) {
      this.$router.push("/");
    } else {
      var token = localStorage.getItem("user-token");
      const decryptedText = this.CryptoJS.AES.decrypt(
        token,
        process.env.VUE_APP_SECRET_KEY
      )
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, "");
      this.dataUser = this.jwt.decode(decryptedText);
      this.oneid = this.dataUser.user.oneid;
      this.clickToAddPassword();
      // this.refrestoken()
    }
  },
  methods: {
    clickToAddPassword() {
      this.key = this.randomPassword(2);
    },
    gojoinpage() {
       this.$router.push({ path: '/joinpage' }).catch(() => {})
    },
    randomPassword(length) {
      var chars = "1234567890";
      var char = "1234567890";
      var number = "1234567890";
      var characters = "1234567890";
      var pass = "";
      var pass1 = "";
      var pass2 = "";
      var pass3 = "";
      var pass4 = "";
      for (var x = 0; x < length; x++) {
        pass += chars.charAt(Math.floor(Math.random() * chars.length));
        pass1 += number.charAt(Math.floor(Math.random() * number.length));
        pass2 += char.charAt(Math.floor(Math.random() * char.length));
        pass3 += characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
        pass4 = pass + pass1 + pass2 + pass3;
      }
      return pass4;
    },
    async refrestoken(){
      var token = localStorage.getItem('user-token')
      await this.axios.post(process.env.VUE_APP_API + '/api/v1/authentication/refrestoken', {
        headers: {
              Authorization: 'bearer ' + token
            }
      }).then(res => {
        // this.checkExpire()
      }).catch(err => {
        this.$swal.fire({          
          title: this.$t("message.Sessiontimeout"),
          text: '',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonText: this.$t("button.btnok"),
          allowOutsideClick: false
        }).then(result => {
          localStorage.clear()
          localStorage.setItem("lang", "th")
          window.open('/', '_self')
        })
      })
    },
    async checkExpire() {
      await this.axios
        .get(process.env.VUE_APP_API + "/api/v1/code/checkExpire")
        .then((res) => {
          if (res.data.result === "expired") {
            this.getSharedToken(res.data.result);
            // this.$router.push("/manage?" + this.key);
          } else if (res.data.result === "Success") {
            this.getSharedToken(res.data.result);
            // this.$router.push("/manage?" + this.key);
          } else {
            this.getSharedToken(res.data.result);
            console.log("err", res.data.result);
          }
        })
        .catch((err) => {
          console.log("err", err.message);
        });
    },

    async getSharedToken(result) {
      await this.axios
        .get(process.env.VUE_APP_ONEID + "/api/v2/service/shared-token")
        .then((res) => {
          if (res.data.result === "Success") {
            this.sharedtoken = res.data.data.shared_token;
            if (result === "expired" || result === "Success") {
              this.loginsharedtoke();
            } else {
              this.loginsharedtokewithGuest();
            }
          } else {
            this.$swal.fire({          
              title: res.data.message,
              text: '',
              icon: 'warning',
              showCancelButton: false,
              confirmButtonText: this.$t("button.btnok"),
              allowOutsideClick: false
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({          
              title: err.data.message,
              text: '',
              icon: 'warning',
              showCancelButton: false,
              confirmButtonText: this.$t("button.btnok"),
              allowOutsideClick: false
            });
        });
    },

    loginsharedtoke() {
      this.axios
        .post(process.env.VUE_APP_API + "/api/v1/vote/login-shared-token", {
          sharedToken: this.sharedtoken,
          oneid: this.oneid,
        })
        .then((res) => {
          // console.log("loginsharedtoke :", res.data.message);
        })
        .catch((err) => {
          console.log("ERROR:loginsharedtoke", err.data.message);
        });
    },
    loginsharedtokewithGuest() {
      this.axios
        .post(
          process.env.VUE_APP_API + "/api/v1/vote/login-shared-token/guest",
          {
            sharedToken: this.sharedtoken,
            oneid: this.oneid,
          }
        )
        .then((res) => {
          // console.log("loginsharedtoke :", res.data.message);
        })
        .catch((err) => {
          console.log("ERROR:loginsharedtoke", err);
        });
    },

    inputlocalStorage() {
      // console.log('inputlocalStorage', this.dataresult.data.token)
      if (this.dataresult.result === "Success") {
        localStorage.setItem("user-token", this.dataresult.data.token);
        this.$swal
          .fire({
            title: "Success",
            text: this.dataresult.data.message,
            icon: "success",
            showCancelButton: false,
            confirmButtonText: this.$t("button.btnok"),
            allowOutsideClick: false,
          })
          .then((res) => {
            // console.log('setItem', result.data.token)
            // window.location.href = "/";
          this.$router.push("/loadding?" + this.key);
          });
      }
    },
    moveToNextField(value, index) {
      // console.log(value.length)
      var setString1 = value.substring(0, 4);
      var setString2 = value.substring(7, 11);
      var setString3 = value.substring(14, 18);
      var setString4 = value.substring(21, 25);
      // console.log(setString1, setString2, setString3, setString4)
      const nextIndex = index + 1;
      if (value.length !== 25) {
        if (nextIndex < this.datainput.length && value.length >= 4) {
          this.$refs.datainput[nextIndex].focus();
        }
      } else {
        this.datainput[0].input = setString1;
        this.datainput[1].input = setString2;
        this.datainput[2].input = setString3;
        this.datainput[3].input = setString4;
      }
    },
    async sentocode() {
      this.input1 = this.datainput[0].input;
      this.input2 = this.datainput[1].input;
      this.input3 = this.datainput[2].input;
      this.input4 = this.datainput[3].input;
      // console.log('datainputs.input1', this.input1)
      const codenumber = this.input1 + this.input2 + this.input3 + this.input4;
      // console.log('datainputs.input1', codenumber)
      if (
        this.input1 === "" ||
        this.input2 === "" ||
        this.input3 === "" ||
        this.input4 === ""
      ) {
        this.$swal.fire({          
              title: this.$t("message.entercode"),
              text: '',
              icon: 'warning',
              showCancelButton: false,
              confirmButtonText: this.$t("button.btnok"),
              allowOutsideClick: false
            });
      } else {
        await this.axios
          .post(process.env.VUE_APP_API + "/api/v1/code/activateAndCreate", {
            code: codenumber,
          })
          .then((result) => {
            // console.log('res', result.data)
            // this.checkExpire()
            if (result.data.result === "Success") {
              if (result.data.data.status === "fail") {
                this.$swal.fire({          
                   title: this.$t("message.codealready"),
                   text: this.$t("message.administrator"),
                   icon: 'warning',
                   showCancelButton: false,
                   confirmButtonText: this.$t("button.btnok"),
                    allowOutsideClick: false
                 });
                this.datainput[0].input = "";
                this.datainput[1].input = "";
                this.datainput[2].input = "";
                this.datainput[3].input = "";
                this.loader = "loading";
              } else if (result.data.data.status === "expired") {
                this.loader = "loading";
                this.datainput[0].input = "";
                this.datainput[1].input = "";
                this.datainput[2].input = "";
                this.datainput[3].input = "";
                this.$swal.fire({          
                   title: this.$t("message.expired"),
                   text: this.$t("message.administrator"),
                   icon: 'warning',
                   showCancelButton: false,
                   confirmButtonText: this.$t("button.btnok"),
                    allowOutsideClick: false
                 });
              } else {
                this.loadersucc = "loading";
                this.dataresult = result.data;
                // console.log('tokenA', tokenA)
                localStorage.removeItem("role");
                localStorage.removeItem("user-token");
                localStorage.setItem('user-token', res.data.data.token)
                this.refrestoken()
              }
            }
          })
          .catch((err) => {
            // console.log("error", err.response);
            this.loader = "loading";
            this.$swal(
              err.response.data.message,
              this.$t("message.incorrect"),
              this.$t("message.administrator"),
              "warning",
              this.$t("button.btnok")
            );
            this.datainput[0].input = "";
            this.datainput[1].input = "";
            this.datainput[2].input = "";
            this.datainput[3].input = "";
          });
      }
    },
  },
};
</script>
